import { CommonModule } from '@angular/common';
import { Component, Input, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogRef, DialogsModule, WindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CasiCloseOptions } from '../../common/constants.lib';
import { LoggerService } from '../../shared/logger.service';

@Component({
  selector: 'casi-delete-confirm',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './delete-confirm.component.html',
  styleUrl: './delete-confirm.component.scss'
})
export class DeleteConfirmComponent  extends DialogContentBase implements OnInit{

  private _title: string = 'Please confirm';
  private _content: string = 'Content not set';

  @Input({ required: true })
  set title(value: string) {
    this._title = value;
  }
  get title(): string | undefined {
    return this._title
  };

  @Input({ required: true })
  set content(val: string) {
    this._content = val;
  }
  get content() {
    return this._content;
  }

  constructor(
    public override dialog: DialogRef,
    private logger: LoggerService,
  ) {
    super(dialog);
  }

  //#region Ng Events

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  //#endregion

  public errorClose(): void {
    this.logger.debug(`errorClose...`);
    this.dialog.close({ text: CasiCloseOptions.Closed });
  }

  public confirmClose(): void {
    this.dialog.close({ text: CasiCloseOptions.Ok });
  }

}
